import $ from "jquery";
import "select2/dist/js/select2.full";
import "./i18n/zh_CN";
import "./i18n/zh_TW";

export default class Select {
    constructor() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === "childList" && mutation.target.id !== "js-clock") {
                    mutation.target.querySelectorAll("select.js-choices, input.js-choices").forEach((element) => {
                        if (!element.classList.contains("select2-hidden-accessible")) {
                            this.transform(element);
                        }
                    });
                }
            });
        });

        observer.observe(document.querySelector("body"), {
            childList: true,
            attributes: true,
            characterData: true,
            subtree: true,
        });
    }

    transform(element) {
        const config = element.dataset.url ? {
            ajax: {
                url: element.dataset.url,
                data: params => ({ q: params.term }),
                processResults: data => ({ results: data }),
            },
            templateResult: (result) => {
                const display = document.createElement("span");
                Object.entries(result).forEach(([key, value]) => {
                    if (key !== "id" && key !== "text" && Object.prototype.hasOwnProperty.call(result, key)) {
                        display.innerHTML += `${value}<br>`;
                    }
                });
                if (display.innerHTML === "") {
                    return result.text;
                }
                if (!result.disabled) {
                    return display;
                }

                return "";
            },
            minimumInputLength: element.dataset.minimumInputLength || 2,
            placeholder: element.placeholder || element.dataset.placeholder || "",
            allowClear: element.dataset.clear || false,
            maximumSelectionLength: element.dataset.maximumSelectionLength || 0,
        } : {
            placeholder: element.placeholder || element.dataset.placeholder || "",
            allowClear: element.dataset.clear || false,
            maximumSelectionLength: element.dataset.maximumSelectionLength || 0,
        };
        $.fn.select2.defaults.set("language", document.documentElement.lang.replace("_", "-"));
        $(element).select2(config);
        // Workaround to avoid JQuery events issue (they don't trigger addEventListener)
        $(element).on("change", () => {
            element.dispatchEvent(new Event("changeOnSelect", { bubbles: true }));
        });
    }
}
